import { defineMessages } from 'react-intl-next';

export default defineMessages({
    searchErrorTitle: {
        defaultMessage: "Can't display search results",
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.results.error.found',
    },

    searchErrorText: {
        defaultMessage: 'Our best engineers are working on it. Try refreshing in a few moments.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.results.error.text',
    },
});
